import './App.css';
import Form from './components/Form/Form';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import useContainerSize from './hooks/useContainerSize';
import useWindowSize from './hooks/useWindowSize';
import useViewportSize from './hooks/useViewportSize';
import { CSSProperties } from 'react';

const RE_CAPTCHA_SITE_KEY = '6LcLoTApAAAAAPPTGyWzHvD9kqUbAwRXQiX-32WC';

function App() {

  const { width, height } = useContainerSize();
  const { width: windowWidth } = useWindowSize();
  const { vw, vh } = useViewportSize();

  let aspectRatioWidth = 1903;
  let aspectRatioHeight = 1080;
  let globalPadding = 140;

  if (width && width <= 800) {
    aspectRatioWidth = 480;
    aspectRatioHeight = 720;
    globalPadding = 40;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RE_CAPTCHA_SITE_KEY}>
      <div
        style={
          {
            '--vw': vw,
            '--vh': vh,
            '--global-content-width': width ? `${width}px` : undefined,
            '--global-content-height': height ? `${height}px` : undefined,
            '--fill-color': width && height ? 'transparent' : 'white',
            '--aspect-ratio-width': aspectRatioWidth,
            '--aspect-ratio-height': aspectRatioHeight,
            '--global-padding': globalPadding,
            maxWidth: windowWidth ? `${windowWidth}px` : undefined,
          } as CSSProperties
        }
      >
          <Form refreshPriority={1} />
      </div>
    </GoogleReCaptchaProvider >
  );
}

export default App;
